import { Box, DialogActions, styled } from '@mui/material';

import { Typography } from '@hapvida/hapvida-core-components';

import Icon from '../Icon';
import type { ModalType, TitleProps } from './types';
import { NEW_COLORS } from '../../themes/colors/newColors';

const colorMap: Record<ModalType, string> = {
  redirect: NEW_COLORS.SECONDARY[500],
  success: NEW_COLORS.SEMANTICS.SUCCESS[800],
  default: NEW_COLORS.PRIMARY[500],
  gray: NEW_COLORS.GRAYSCALE[700],
  alert: NEW_COLORS.SEMANTICS.ERROR[600],
};

export const WrapperModal = styled(Box)`
  background-color: ${NEW_COLORS.BASE.WHITE};
`;

export const Title = styled(Typography)<TitleProps>(({ type }) => ({
  color: colorMap[type],
  lineHeight: '20px',
}));

export const StyledIcon = styled(Box)<TitleProps>(({ type }) => ({
  color: colorMap[type],
  minWidth: '32px',
}));

export const Footer = styled(DialogActions)`
  padding: 16px;
  gap: 16px;
`;
